const config = {
  name: `VeriTooth`,
  rootUrl: `https://app.veritooth.com`,
  openGraph: `https://app.veritooth.com/og.jpg`,
  meta: {
    separator: ` – `,
  },
  transitionDuration: 300,
  gtag: {
    scriptSource: `https://www.googletagmanager.com/gtag/js`,
    gtagId: `UA-137817635-1`,
  },
  stripe_publishable_key: process.env.NODE_ENV === `production` ? // eslint-disable-line no-undef
    `pk_live_ePrkHuYMwLMOG6N4e2ocF74D00hLs6KvuZ` :
    `pk_test_4MQbQMZLPP4JQW1QxlvkcFh700Qd3L0U1m`,
};

const apiMap = {
  local: `http://localhost:8000/api`,
  dev: `https://backend-dev.veritooth.com/api`,
  qa: `https://backend-qa.veritooth.com/api`,
  prod: `https://admin.veritooth.com/api`,
};

const wpMap = {
  local: `http://veritooth.t29dev.com`,
  dev: `http://veritooth.t29dev.com`,
  qa: `http://veritooth.t29dev.com`,
  prod: `https://veritooth.com`,
};

const envMap = {
  qa: `qa`,
  production: `prod`,
  development: `dev`,
  local: `local`,
};

const env = envMap[process.env.NODE_ENV] || `dev`; // eslint-disable-line no-undef

export default {
  ...config,
  env,
  api: apiMap[env],
  wp: wpMap[env],
};



// WEBPACK FOOTER //
// ./client/config.js